import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth.services'

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['../promotion.component.css'],
})
export class HeaderComponent implements OnInit {
    en = {}
    showEN = true

    constructor(private auth: AuthService) {
    }

    ngOnInit() {
    }

    changeLanguage() {
        const lang_default = localStorage.getItem('lang')
        if (lang_default === 'false') {
            this.showEN = false
            return this.en = this.auth.showLang(false)
        } else {
            this.showEN = true
            return this.en = this.auth.showLang(true)
        }
    }

    changeEN() {
        localStorage.setItem('lang', 'true')
        this.showEN = true
    }

    changeJAN() {
        localStorage.setItem('lang', 'false')
        this.showEN = false
    }

}



// WEBPACK FOOTER //
// ./src/app/promotion/layout-promotion/header.component.ts